import { cn } from '@/shadcn/lib/utils';
import { memo } from 'react';

interface Props {
  fileExtensionWhitelistMap: any;
  filesLength: number;
}

export const AcceptedFilesDescription = memo(
  ({ fileExtensionWhitelistMap }: Props) => {
    if (!fileExtensionWhitelistMap) return null;
    const fileExtensionsWhiteList: any[] = Object.entries(
      fileExtensionWhitelistMap
    );

    return (
      <div className={cn('mb-0')}>
        <h5 className="mb-2.5 text-xs font-semibold">Accepted file types</h5>
        <ul>
          {/* First we extract the category and its extensions */}
          {fileExtensionsWhiteList.map(([category, extensionsList]) => {
            const extensionLength = extensionsList.length;

            return (
              <li
                key={category}
                className="text-foreground text-[10px] not-last:mb-1 first-letter:uppercase"
              >
                {category}

                {/* Then, we map on a category's extensions */}
                {extensionsList.map((extension, index) => {
                  if (index < 3)
                    return (
                      <span
                        key={extension}
                        className="text-muted-foreground pl-0.5"
                      >
                        {extension},
                      </span>
                    );
                  if (index === 3 && extensionLength > 3)
                    // If we have more than 4 extensions, add the rest of the array in the html title attribute (aka tooltip)
                    return (
                      <span
                        className={cn(
                          'text-muted-foreground pl-0.5',
                          extensionLength > 4 && 'after:content-[...]'
                        )}
                        key={extension}
                        title={extensionsList.slice(index + 1)}
                      >
                        {extension}
                      </span>
                    );
                  return null;
                })}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
);
